import perfectAudio from '../res/bingbingbing.mp3';
import deathAudio from '../res/death.mp3';
import breakthroughAudio from '../res/breakthrough.mp3';
import {STORAGE_TIME} from '../config/constant';

const recordings = {perfect: perfectAudio, fail: deathAudio, breakthrough: breakthroughAudio};

export default class Sound {
  constructor(enabled = true) { this.enabled = enabled; this.buffers = {}; }
  get enabled() { return this._enabled; }
  set enabled(value) { this._enabled = value; if (!value) this.stopCharge(); }
  unlock() {
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio || !this.enabled) return;
    try {
      if (!this.context) this.context = new Audio();
      if (this.context.state === 'suspended') this.context.resume().catch(() => {});
      Object.entries(recordings).forEach(([kind, url]) => {
        if (this.buffers[kind]) return;
        this.buffers[kind] = fetch(url)
          .then(response => {
            if (!response.ok) throw new Error('Audio unavailable');
            return response.arrayBuffer();
          })
          .then(data => this.context.decodeAudioData(data))
          .catch(() => { delete this.buffers[kind]; return null; });
      });
    } catch (_) { /* Audio is optional. */ }
  }
  play(kind) {
    if (!this.enabled || !this.context) return;
    if (kind === 'charge') { this.startCharge(); return; }
    if (recordings[kind]) {
      return this.buffers[kind]?.then(buffer => {
        if (!buffer || !this.enabled) return;
        const source = this.context.createBufferSource();
        source.buffer = buffer;
        source.connect(this.context.destination);
        source.onended = () => source.disconnect();
        source.start();
      });
    }
    const notes = {
      charge: [180, 280, 0.12], jump: [300, 620, 0.16],
      land: [180, 90, 0.12]
    };
    if (!notes[kind]) return;
    const [from, to, duration] = notes[kind];
    const context = this.context;
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const time = context.currentTime;
    oscillator.frequency.setValueAtTime(from, time);
    oscillator.frequency.exponentialRampToValueAtTime(to, time + duration);
    gain.gain.setValueAtTime(0.0001, time);
    gain.gain.exponentialRampToValueAtTime(0.045, time + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, time + duration);
    oscillator.connect(gain); gain.connect(context.destination);
    oscillator.start(time); oscillator.stop(time + duration);
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
  }
  startCharge() {
    this.stopCharge();
    const context = this.context;
    if (!this.enabled || !context) return;
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const time = context.currentTime;
    oscillator.type = 'triangle';
    oscillator.frequency.setValueAtTime(180, time);
    oscillator.frequency.exponentialRampToValueAtTime(520, time + STORAGE_TIME / 1000);
    gain.gain.setValueAtTime(.0001, time);
    gain.gain.exponentialRampToValueAtTime(.21, time + .04);
    oscillator.connect(gain); gain.connect(context.destination);
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
    this.charging = {oscillator, gain}; oscillator.start(time);
  }
  stopCharge() {
    if (!this.charging) return;
    const {oscillator, gain} = this.charging;
    this.charging = null;
    const time = this.context.currentTime;
    gain.gain.cancelScheduledValues(time);
    gain.gain.setTargetAtTime(.0001, time, .008);
    oscillator.stop(time + .04);
  }
}
